import isEmpty from "lodash/isEmpty";
import isNull from "lodash/isNull";
import isNumber from "lodash/isNumber";
const NUMBER_REGEX = /[+-]?\d+(\.\d+)?/u;
const SQRT2 = Math.sqrt(2);
const parseNumber = (value) => {
  if (isNumber(value))
    return value;
  const match = value.match(NUMBER_REGEX);
  if (!isEmpty(match) && !isNull(match))
    return parseFloat(match[0]);
  return NaN;
};
const getInscribedSquareSide = (diameter) => {
  return diameter / SQRT2;
};
const calculatePosition = (positionY, positionX, currentControlSize, isSquare, positionRatio = void 0) => {
  const extractedCurrentControlSize = parseNumber(currentControlSize);
  const squareK = positionRatio ? 1.8 : 1.35;
  const k = isSquare ? squareK : 1;
  const customK = !isSquare && positionRatio ? positionRatio : [1, 1];
  return {
    [`${positionY}`]: `-${extractedCurrentControlSize * k * customK[0] / 2}px`,
    [`${positionX}`]: `-${extractedCurrentControlSize * k * customK[1] / 2}px`
  };
};
const IS_GRADIENT_REGEX = /gradient/u;
const containsGradient = (str) => {
  return IS_GRADIENT_REGEX.test(str);
};
export {
  calculatePosition,
  containsGradient,
  getInscribedSquareSide,
  parseNumber
};
